webpackJsonp([256871573202158],{

/***/ 569:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AnchorIcon() {
	  return _react2.default.createElement(
	    "svg",
	    {
	      xmlns: "http://www.w3.org/2000/svg",
	      width: "21",
	      height: "21",
	      viewBox: "0 0 21 21"
	    },
	    _react2.default.createElement(
	      "g",
	      { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
	      _react2.default.createElement(
	        "g",
	        { fill: "#FFF", fillRule: "nonzero", transform: "translate(-961 -1344)" },
	        _react2.default.createElement(
	          "g",
	          { transform: "translate(926 1175)" },
	          _react2.default.createElement("path", { d: "M56 182.883l-.583-4.083c-.117-.7-.7-1.167-1.284-1.167-.35 0-.7.117-.933.467l-2.8 2.917-.233.233c-.467.583-.35 1.517.35 1.983l.35.234h.116C50.4 184.75 49 185.683 47.6 186.15v-7c1.867-.817 3.267-2.683 3.267-4.9-.117-2.917-2.45-5.25-5.367-5.25a5.228 5.228 0 00-5.25 5.25c0 2.217 1.4 4.083 3.267 4.9v7.117c-1.4-.467-2.684-1.4-3.384-2.684h.117c.117 0 .233-.116.35-.233.35-.233.467-.583.583-.933 0-.35 0-.817-.233-1.05-.117-.117-.117-.234-.233-.234l-2.8-3.033c-.234-.35-.584-.467-.934-.467-.7 0-1.166.467-1.4 1.167L35 182.883v.35c0 .817.583 1.4 1.4 1.4.117 0 .35 0 .467-.116h.116C38.267 187.783 41.767 190 45.5 190c3.733 0 7.233-2.217 8.517-5.483h.116c.117 0 .234.116.467.116.817 0 1.4-.7 1.4-1.4v-.35zm-10.5-11.316a2.59 2.59 0 012.567 2.566A2.59 2.59 0 0145.5 176.7a2.59 2.59 0 01-2.567-2.567c-.116-1.283 1.167-2.566 2.567-2.566z" })
	        )
	      )
	    )
	  );
	}
	
	exports.default = AnchorIcon;
	module.exports = exports["default"];

/***/ }),

/***/ 570:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AnchorPreview() {
	  return _react2.default.createElement(
	    "svg",
	    {
	      xmlns: "http://www.w3.org/2000/svg",
	      width: "108",
	      height: "108",
	      viewBox: "0 0 108 108"
	    },
	    _react2.default.createElement(
	      "g",
	      { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
	      _react2.default.createElement(
	        "g",
	        { transform: "translate(-1050 -1228)" },
	        _react2.default.createElement(
	          "g",
	          { transform: "translate(926 1175)" },
	          _react2.default.createElement(
	            "g",
	            { transform: "translate(124 53)" },
	            _react2.default.createElement("path", { fill: "#FFF", d: "M0 0H108V108H0z" }),
	            _react2.default.createElement("path", {
	              fill: "#EFEFEF",
	              d: "M93 98a4 4 0 014 4v6H10v-6a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V73a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V44a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V15a4 4 0 014-4h79z"
	            }),
	            _react2.default.createElement("rect", {
	              width: "30",
	              height: "30",
	              x: "69",
	              y: "71",
	              fill: "currentColor",
	              rx: "4"
	            }),
	            _react2.default.createElement("path", {
	              fill: "#C5C5C5",
	              fillRule: "nonzero",
	              d: "M51.39 75.02a2.652 2.652 0 002.13-2.598V52.539h12.5c.625 0 1.25-.625 1.25-1.25 0-.45-.176-.8-.508-1.016l-.02-.02L52.758 36.25c-.899-.996-2.5-.996-3.516 0l-14.12 14.121c-.411.41-.49.86-.255 1.387.137.469.625.742 1.153.742h12.5v20c0 1.523 1.386 2.773 2.87 2.52z"
	            })
	          )
	        )
	      )
	    )
	  );
	}
	
	exports.default = AnchorPreview;
	module.exports = exports["default"];

/***/ }),

/***/ 571:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ContainersIcon() {
	  return _react2.default.createElement(
	    "svg",
	    {
	      xmlns: "http://www.w3.org/2000/svg",
	      width: "18",
	      height: "18",
	      viewBox: "0 0 18 18"
	    },
	    _react2.default.createElement(
	      "g",
	      { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
	      _react2.default.createElement(
	        "g",
	        { fill: "#FFF", fillRule: "nonzero", transform: "translate(-172 -1346)" },
	        _react2.default.createElement(
	          "g",
	          { transform: "translate(136 1175)" },
	          _react2.default.createElement("path", { d: "M52.615 171c.765 0 1.385.62 1.385 1.385v15.23c0 .765-.62 1.385-1.385 1.385h-15.23c-.765 0-1.385-.62-1.385-1.385v-15.23c0-.765.62-1.385 1.385-1.385h15.23zm-4.153 13.846h-9.693a1.385 1.385 0 00-.161 2.76l.161.01h9.693a1.385 1.385 0 00.161-2.76l-.161-.01zm2.769-12.461c-.71 0-1.296.534-1.376 1.223l-.009.161v4.154a1.385 1.385 0 002.76.162l.01-.162v-4.154c0-.764-.62-1.384-1.385-1.384z" })
	        )
	      )
	    )
	  );
	}
	
	exports.default = ContainersIcon;
	module.exports = exports["default"];

/***/ }),

/***/ 572:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ContainersPreview() {
	  return _react2.default.createElement(
	    "svg",
	    {
	      xmlns: "http://www.w3.org/2000/svg",
	      width: "108",
	      height: "108",
	      viewBox: "0 0 108 108"
	    },
	    _react2.default.createElement(
	      "g",
	      { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
	      _react2.default.createElement(
	        "g",
	        { transform: "translate(-260 -1228)" },
	        _react2.default.createElement(
	          "g",
	          { transform: "translate(136 1175)" },
	          _react2.default.createElement(
	            "g",
	            { transform: "translate(124 53)" },
	            _react2.default.createElement("path", { fill: "#FFF", d: "M0 0H108V108H0z" }),
	            _react2.default.createElement("path", {
	              fill: "#EFEFEF",
	              d: "M93 98a4 4 0 014 4v6H10v-6a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V73a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V44a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V15a4 4 0 014-4h79z"
	            }),
	            _react2.default.createElement("rect", {
	              width: "31",
	              height: "31",
	              x: "10",
	              y: "11",
	              fill: "currentColor",
	              rx: "4"
	            })
	          )
	        )
	      )
	    )
	  );
	}
	
	exports.default = ContainersPreview;
	module.exports = exports["default"];

/***/ }),

/***/ 573:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function EmbedIcon() {
	  return _react2.default.createElement(
	    "svg",
	    {
	      xmlns: "http://www.w3.org/2000/svg",
	      width: "20",
	      height: "20",
	      viewBox: "0 0 20 20"
	    },
	    _react2.default.createElement(
	      "g",
	      { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
	      _react2.default.createElement(
	        "g",
	        { fill: "#FFF", fillRule: "nonzero", transform: "translate(-566 -1345)" },
	        _react2.default.createElement(
	          "g",
	          { transform: "translate(531 1175)" },
	          _react2.default.createElement("path", { d: "M48.125 170c-1.875 0-3.625.75-5.25 2.375-1.5 1.625-2.25 3.25-2.375 5.125 0 1.875.625 3.5 2.125 5 .375.375.75.625 1.125.875.875-1.125 1.25-2.5 1-4.125l.25.25.5.75c.5.875.625 1.75.5 2.5-.125.875-.625 1.75-1.375 2.375-1 .875-1.875 1.375-2.875 1.375-.875 0-1.625-.375-2.375-1-.625-.625-1-1.375-1-2.125s.125-1.5.75-2.25c-.5-1.375-.75-2.75-.625-4.125-.5.375-.75.625-1.125.875C35.875 179.5 35 181.125 35 183s.625 3.5 2.125 5c1.375 1.25 2.875 2 4.75 2 .75 0 1.5-.125 2.125-.375.75-.25 1.375-.625 2.125-1.125 1.125-.875 2-1.875 2.625-3 .25-.375.375-.75.375-.875.5-1.25.5-2.5.25-3.75s-1-2.375-1.875-3.375c-.875-.875-1.75-1.375-2.875-1.75.125-.25.375-.625.75-1 1-.875 1.875-1.375 2.875-1.375.875 0 1.625.375 2.375 1 .75.75 1 1.5 1 2.375 0 .625-.25 1.375-.75 2.125.5 1.125.75 2.25.75 3.375v.75c.375-.25.75-.5 1-.875C54.25 180.5 55 178.75 55 176.875c0-1.75-.75-3.375-2.125-4.75S50 170 48.125 170z" })
	        )
	      )
	    )
	  );
	}
	
	exports.default = EmbedIcon;
	module.exports = exports["default"];

/***/ }),

/***/ 574:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function EmbedMultimediaIcon() {
	  return _react2.default.createElement(
	    "svg",
	    {
	      xmlns: "http://www.w3.org/2000/svg",
	      width: "15",
	      height: "18",
	      viewBox: "0 0 15 18"
	    },
	    _react2.default.createElement(
	      "g",
	      { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
	      _react2.default.createElement(
	        "g",
	        { fill: "#FFF", transform: "translate(-964 -2145)" },
	        _react2.default.createElement(
	          "g",
	          { transform: "translate(926 1975)" },
	          _react2.default.createElement("path", { d: "M39.66 170a1.293 1.293 0 00-.707.203c-.34.208-.57.566-.629.97l-.048.623-.08.862-.035.469-.03.541-.025.614-.022.688-.009.37a92.755 92.755 0 00-.075 3.654c0 .877.014 1.784.042 2.72l.048 1.318.06 1.306.045.782.06.823.061.687.005.043c.007.469.252.898.643 1.124.213.136.458.206.707.203.163-.014.322-.055.472-.124a49.017 49.017 0 0012.384-7.757c.317-.276.492-.693.471-1.125a1.284 1.284 0 00-.471-1.056l-.056-.057-.156-.145-.342-.297-.256-.212-.426-.338-.989-.76-.239-.181a55.68 55.68 0 00-2.625-1.867c-.921-.622-2.039-1.3-3.353-2.035a39.82 39.82 0 00-3.942-1.933 1.424 1.424 0 00-.482-.113z" })
	        )
	      )
	    )
	  );
	}
	
	exports.default = EmbedMultimediaIcon;
	module.exports = exports["default"];

/***/ }),

/***/ 575:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function EmbedPreview() {
	  return _react2.default.createElement(
	    "svg",
	    {
	      xmlns: "http://www.w3.org/2000/svg",
	      width: "108",
	      height: "108",
	      viewBox: "0 0 108 108"
	    },
	    _react2.default.createElement(
	      "g",
	      { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
	      _react2.default.createElement(
	        "g",
	        { transform: "translate(-668 -1228)" },
	        _react2.default.createElement(
	          "g",
	          { transform: "translate(531 1175)" },
	          _react2.default.createElement(
	            "g",
	            { transform: "translate(137 53)" },
	            _react2.default.createElement("path", { fill: "#FFF", d: "M0 0H108V108H0z" }),
	            _react2.default.createElement("path", {
	              fill: "#EFEFEF",
	              d: "M93 99a4 4 0 014 4v5H10v-5a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V74a4 4 0 014-4h79z"
	            }),
	            _react2.default.createElement("path", {
	              fill: "currentColor",
	              d: "M93 11a4 4 0 014 4v41a4 4 0 01-4 4H14a4 4 0 01-4-4V15a4 4 0 014-4h79zM47.55 27a1.251 1.251 0 00-.66.18 1.21 1.21 0 00-.587.864l-.045.554-.076.766-.032.417-.027.482-.024.546-.02.611c-.004.107-.006.217-.009.33A78.62 78.62 0 0046 35c0 .78.013 1.586.04 2.419l.044 1.173.056 1.16.042.697.057.731.056.612.005.038c.006.417.235.799.6 1 .199.12.428.183.66.18.152-.012.3-.05.44-.11A46.15 46.15 0 0059.56 36a1.22 1.22 0 00.44-1 1.12 1.12 0 00-.44-.94l-.052-.05-.146-.13-.319-.263-.24-.19-.397-.3-.922-.675-.224-.162a52.033 52.033 0 00-2.45-1.66 44.688 44.688 0 00-3.13-1.81A37.967 37.967 0 0048 27.1a1.384 1.384 0 00-.45-.1z"
	            })
	          )
	        )
	      )
	    )
	  );
	}
	
	exports.default = EmbedPreview;
	module.exports = exports["default"];

/***/ }),

/***/ 576:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function EmbedPreview() {
	  return _react2.default.createElement(
	    "svg",
	    {
	      xmlns: "http://www.w3.org/2000/svg",
	      width: "108",
	      height: "108",
	      viewBox: "0 0 108 108"
	    },
	    _react2.default.createElement(
	      "g",
	      { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
	      _react2.default.createElement(
	        "g",
	        { transform: "translate(-668 -1228)" },
	        _react2.default.createElement(
	          "g",
	          { transform: "translate(531 1175)" },
	          _react2.default.createElement(
	            "g",
	            { transform: "translate(137 53)" },
	            _react2.default.createElement("path", { fill: "#FFF", d: "M0 0H108V108H0z" }),
	            _react2.default.createElement("path", {
	              fill: "#EFEFEF",
	              d: "M93 99a4 4 0 014 4v5H10v-5a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V74a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V45a4 4 0 014-4h79z"
	            }),
	            _react2.default.createElement("path", {
	              fill: "currentColor",
	              d: "M48 13a4 4 0 014 4v11a4 4 0 01-4 4H14a4 4 0 01-4-4V17a4 4 0 014-4h34zm-15.438 4c-.937 0-1.812.375-2.624 1.188-.75.812-1.125 1.625-1.188 2.562 0 .938.313 1.75 1.063 2.5.187.188.375.313.562.438.438-.563.625-1.25.5-2.063l.125.125.25.375c.25.438.313.875.25 1.25a1.945 1.945 0 01-.688 1.188c-.5.437-.937.687-1.437.687-.438 0-.813-.188-1.188-.5-.312-.313-.5-.688-.5-1.063s.063-.75.375-1.125c-.25-.687-.375-1.375-.312-2.062-.25.188-.375.313-.563.438C26.438 21.75 26 22.563 26 23.5c0 .938.313 1.75 1.063 2.5.687.625 1.437 1 2.375 1 .375 0 .75-.063 1.062-.188.375-.125.688-.312 1.063-.562.562-.438 1-.938 1.312-1.5.125-.188.188-.375.188-.438.25-.625.25-1.25.124-1.875-.124-.625-.5-1.187-.937-1.687a3.441 3.441 0 00-1.438-.875c.063-.125.188-.313.375-.5.5-.438.938-.688 1.438-.688.438 0 .813.188 1.188.5.374.375.5.75.5 1.188 0 .313-.126.688-.376 1.063.25.562.376 1.125.376 1.687v.375c.187-.125.374-.25.5-.438.812-.812 1.187-1.687 1.187-2.625 0-.875-.375-1.687-1.063-2.375C34.25 17.375 33.5 17 32.563 17z"
	            })
	          )
	        )
	      )
	    )
	  );
	}
	
	exports.default = EmbedPreview;
	module.exports = exports["default"];

/***/ }),

/***/ 577:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FixedHeaderFooterIcon() {
	  return _react2.default.createElement(
	    "svg",
	    {
	      xmlns: "http://www.w3.org/2000/svg",
	      width: "25",
	      height: "20",
	      viewBox: "0 0 25 20"
	    },
	    _react2.default.createElement(
	      "g",
	      { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
	      _react2.default.createElement(
	        "g",
	        { fill: "#FFF", fillRule: "nonzero", transform: "translate(-959 -1745)" },
	        _react2.default.createElement("path", { d: "M984 1763a2 2 0 01-2 2h-21a2 2 0 01-2-2v-16a2 2 0 012-2h21a2 2 0 012 2v16zm-3-12h-19v11h19v-11z" })
	      )
	    )
	  );
	}
	
	exports.default = FixedHeaderFooterIcon;
	module.exports = exports["default"];

/***/ }),

/***/ 578:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FixedHeaderFooterPreview() {
	  return _react2.default.createElement(
	    "svg",
	    {
	      xmlns: "http://www.w3.org/2000/svg",
	      width: "108",
	      height: "108",
	      viewBox: "0 0 108 108"
	    },
	    _react2.default.createElement(
	      "g",
	      { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
	      _react2.default.createElement("path", { fill: "#FFF", d: "M0 0H108V108H0z" }),
	      _react2.default.createElement("path", {
	        fill: "#EFEFEF",
	        d: "M93 99a4 4 0 014 4v6H10v-6a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V74a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V45a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V16a4 4 0 014-4h79z"
	      }),
	      _react2.default.createElement("path", { fill: "currentColor", d: "M0 0H108V22H0z" })
	    )
	  );
	}
	
	exports.default = FixedHeaderFooterPreview;
	module.exports = exports["default"];

/***/ }),

/***/ 579:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function GifIcon() {
	  return _react2.default.createElement(
	    "svg",
	    {
	      xmlns: "http://www.w3.org/2000/svg",
	      width: "28",
	      height: "28",
	      viewBox: "0 0 28 28"
	    },
	    _react2.default.createElement(
	      "g",
	      { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
	      _react2.default.createElement(
	        "g",
	        { fill: "#FFF", fillRule: "nonzero", transform: "translate(-167 -2541)" },
	        _react2.default.createElement(
	          "g",
	          { transform: "translate(136 2375)" },
	          _react2.default.createElement(
	            "g",
	            { transform: "translate(31 166)" },
	            _react2.default.createElement("path", { d: "M12.25 20.708a.292.292 0 00-.292-.291H9.333A2.333 2.333 0 017 18.083v-1.75c0-.322.261-.583.583-.583h4.375c.161 0 .292-.13.292-.292v-1.166a.292.292 0 00-.292-.292H7.583A.583.583 0 017 13.417V9.333c0-.322.261-.583.583-.583h8.167c.322 0 .583.261.583.583v2.625c0 .161.13.292.292.292h2.917c.16 0 .291-.13.291-.292V4.667A4.667 4.667 0 0015.167 0h-14a1.167 1.167 0 100 2.333A2.333 2.333 0 013.5 4.667v13.416a4.667 4.667 0 004.667 4.667h3.791c.161 0 .292-.13.292-.292v-1.75zm4.083-14.291A.583.583 0 0115.75 7H7.583A.583.583 0 017 6.417v-3.5c0-.322.261-.584.583-.584H14a2.333 2.333 0 012.333 2.334v1.75z" }),
	            _react2.default.createElement("path", { d: "M28 15.75A1.75 1.75 0 0026.25 14h-10.5A1.75 1.75 0 0014 15.75v10.5c0 .966.784 1.75 1.75 1.75h10.5A1.75 1.75 0 0028 26.25v-10.5zm-4.625 6.183l-3.634 2.124a1.099 1.099 0 01-1.658-.934v-4.246a1.1 1.1 0 011.66-.934l3.634 2.124a1.078 1.078 0 01-.002 1.866z" })
	          )
	        )
	      )
	    )
	  );
	}
	
	exports.default = GifIcon;
	module.exports = exports["default"];

/***/ }),

/***/ 580:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function GifIcon() {
	  return _react2.default.createElement(
	    "svg",
	    {
	      xmlns: "http://www.w3.org/2000/svg",
	      width: "108",
	      height: "108",
	      viewBox: "0 0 108 108"
	    },
	    _react2.default.createElement(
	      "g",
	      { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
	      _react2.default.createElement("path", { fill: "#FFF", d: "M0 0H108V108H0z" }),
	      _react2.default.createElement("path", {
	        fill: "#FFF",
	        fillRule: "nonzero",
	        d: "M80.19 65.983a1.333 1.333 0 001.048-1.313V54.615h6.147c.308 0 .615-.316.615-.632 0-.227-.086-.405-.25-.514l-.01-.01-6.877-7.081c-.442-.504-1.23-.504-1.729 0l-6.945 7.14c-.202.208-.24.435-.125.702.068.237.308.375.567.375h6.148V64.71c0 .77.682 1.403 1.412 1.274z",
	        transform: "rotate(-90 80 56)"
	      }),
	      _react2.default.createElement("path", {
	        fill: "currentColor",
	        d: "M93 11a4 4 0 014 4v78a4 4 0 01-4 4H15a4 4 0 01-4-4V15a4 4 0 014-4h78zM48.55 46a1.251 1.251 0 00-.66.18 1.21 1.21 0 00-.587.864l-.045.554-.076.766-.032.417-.027.482-.024.546-.02.611c-.004.108-.006.217-.009.33A78.62 78.62 0 0047 54c0 .78.013 1.586.04 2.419l.044 1.173.056 1.16.042.697.057.731.056.612.005.038c.006.417.235.799.6 1 .199.12.428.183.66.18.152-.012.3-.049.44-.11A46.15 46.15 0 0060.56 55a1.22 1.22 0 00.44-1 1.12 1.12 0 00-.44-.94l-.052-.05-.146-.13-.319-.263-.24-.19-.397-.3-.922-.675-.224-.162a52.033 52.033 0 00-2.45-1.66 44.688 44.688 0 00-3.13-1.81A37.967 37.967 0 0049 46.1a1.384 1.384 0 00-.45-.1z"
	      })
	    )
	  );
	}
	
	exports.default = GifIcon;
	module.exports = exports["default"];

/***/ }),

/***/ 581:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function LastVisitedIcon() {
	  return _react2.default.createElement(
	    "svg",
	    {
	      xmlns: "http://www.w3.org/2000/svg",
	      width: "21",
	      height: "21",
	      viewBox: "0 0 21 21"
	    },
	    _react2.default.createElement(
	      "g",
	      { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
	      _react2.default.createElement(
	        "g",
	        { fill: "#FFF", fillRule: "nonzero", transform: "translate(-566 -1744)" },
	        _react2.default.createElement(
	          "g",
	          { transform: "translate(531 1575)" },
	          _react2.default.createElement(
	            "g",
	            { transform: "translate(35 169)" },
	            _react2.default.createElement("path", { d: "M19.425 7.458c-.263-.131-1.313-.393-2.888-.785-1.575-.393-1.575-.393-3.28-.654V1.177c0-.393-.132-.653-.395-.785C12.6.131 12.337 0 12.075 0s-.525.13-.788.261C9.581 1.308 7.612 2.617 5.775 4.318c-1.838 1.57-3.15 2.747-3.938 3.663a27.441 27.441 0 01-1.575 1.7c-.13.263-.262.524-.262.786s.131.523.262.786c.263.261.788.915 1.575 1.7.788.916 2.1 2.093 3.938 3.795 1.837 1.57 3.937 2.878 5.512 4.055.394.263.788.263 1.182 0 .393-.261.525-.523.525-1.046v-4.972c1.706-.262 1.837-.262 3.412-.654s2.494-.655 2.888-.786C20.475 12.823 21 11.776 21 10.468c0-1.44-.525-2.355-1.575-3.01z" })
	          )
	        )
	      )
	    )
	  );
	}
	
	exports.default = LastVisitedIcon;
	module.exports = exports["default"];

/***/ }),

/***/ 582:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function LastVisitedPreview() {
	  return _react2.default.createElement(
	    "svg",
	    {
	      xmlns: "http://www.w3.org/2000/svg",
	      width: "108",
	      height: "108",
	      viewBox: "0 0 108 108"
	    },
	    _react2.default.createElement(
	      "g",
	      { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
	      _react2.default.createElement("path", { fill: "#FFF", d: "M0 0H108V108H0z" }),
	      _react2.default.createElement("path", {
	        fill: "#EFEFEF",
	        d: "M93 98a4 4 0 014 4v6H10v-6a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V73a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V44a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V15a4 4 0 014-4h79z"
	      }),
	      _react2.default.createElement("rect", { width: "31", height: "31", x: "39", y: "38", fill: "currentColor", rx: "4" }),
	      _react2.default.createElement("path", {
	        fill: "#FFF",
	        fillRule: "nonzero",
	        d: "M55.143 59.988a.95.95 0 00.785-.92v-7.037h4.61c.231 0 .462-.222.462-.443a.4.4 0 00-.187-.36l-.008-.006-5.158-4.958c-.331-.352-.922-.352-1.296 0l-5.21 5c-.15.144-.18.303-.093.49.05.166.23.263.425.263h4.611v7.08c0 .539.511.981 1.059.891z",
	        transform: "rotate(-90 55 53)"
	      })
	    )
	  );
	}
	
	exports.default = LastVisitedPreview;
	module.exports = exports["default"];

/***/ }),

/***/ 583:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function LayersIcon() {
	  return _react2.default.createElement(
	    "svg",
	    {
	      xmlns: "http://www.w3.org/2000/svg",
	      width: "22",
	      height: "22",
	      viewBox: "0 0 22 22"
	    },
	    _react2.default.createElement(
	      "g",
	      { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
	      _react2.default.createElement(
	        "g",
	        { fill: "#FFF", fillRule: "nonzero", transform: "translate(-170 -1743)" },
	        _react2.default.createElement(
	          "g",
	          { transform: "translate(136 1575)" },
	          _react2.default.createElement(
	            "g",
	            { transform: "translate(34 168)" },
	            _react2.default.createElement("path", { d: "M22 7.333L11 0 0 7.333l11 7.334 11-7.334zM11 18.606L3.056 13.2 0 14.96 11 22l11-7.04-2.933-1.634L11 18.606z" })
	          )
	        )
	      )
	    )
	  );
	}
	
	exports.default = LayersIcon;
	module.exports = exports["default"];

/***/ }),

/***/ 584:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function LayersPreview() {
	  return _react2.default.createElement(
	    "svg",
	    {
	      xmlns: "http://www.w3.org/2000/svg",
	      width: "108",
	      height: "108",
	      viewBox: "0 0 108 108"
	    },
	    _react2.default.createElement(
	      "g",
	      { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
	      _react2.default.createElement("path", { fill: "#FFF", d: "M0 0H108V108H0z" }),
	      _react2.default.createElement("path", {
	        fill: "#EFEFEF",
	        d: "M93 98a4 4 0 014 4v6H10v-6a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V73a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V44a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V15a4 4 0 014-4h79z"
	      }),
	      _react2.default.createElement("rect", {
	        width: "44",
	        height: "44",
	        x: "32.5",
	        y: "32.5",
	        fill: "currentColor",
	        rx: "4"
	      })
	    )
	  );
	}
	
	exports.default = LayersPreview;
	module.exports = exports["default"];

/***/ }),

/***/ 585:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TimersIcon() {
	  return _react2.default.createElement(
	    "svg",
	    {
	      xmlns: "http://www.w3.org/2000/svg",
	      width: "19",
	      height: "22",
	      viewBox: "0 0 19 22"
	    },
	    _react2.default.createElement(
	      "g",
	      { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
	      _react2.default.createElement(
	        "g",
	        { fill: "#FFF", fillRule: "nonzero", transform: "translate(-171 -2143)" },
	        _react2.default.createElement(
	          "g",
	          { transform: "translate(136 1975)" },
	          _react2.default.createElement(
	            "g",
	            { transform: "translate(35 168)" },
	            _react2.default.createElement("path", { d: "M13.563 0c.75 0 1.357.615 1.357 1.374 0 .76-.607 1.375-1.357 1.375H10.85v.11a9.435 9.435 0 014.22 1.745c.075-.178.18-.341.313-.481l.895-.907c.622-.63 1.631-.63 2.253 0 .622.63.622 1.651 0 2.281l-.896.907c-.134.128-.29.23-.461.303a9.718 9.718 0 01-.221 11.64c-2.647 3.389-7.2 4.575-11.134 2.9C1.885 19.573-.463 15.448.077 11.162c.54-4.286 3.835-7.682 8.058-8.303v-.11H5.42c-.75 0-1.357-.616-1.357-1.375S4.671 0 5.42 0zM9.492 5.497c-3.748 0-6.786 3.077-6.786 6.872s3.038 6.872 6.786 6.872c3.747 0 6.785-3.077 6.785-6.872S13.24 5.497 9.492 5.497zM7.035 9.813a.726.726 0 01.978 0l1.357 1.21c.236-.101.49-.153.746-.152 1.15 0 2.085.942 2.09 2.107.005 1.166-.921 2.116-2.072 2.126-1.15.01-2.093-.924-2.108-2.09.002-.267.052-.533.15-.782L6.98 10.857a.692.692 0 01-.19-.536.732.732 0 01.244-.508z" })
	          )
	        )
	      )
	    )
	  );
	}
	
	exports.default = TimersIcon;
	module.exports = exports["default"];

/***/ }),

/***/ 586:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TimersPreview() {
	  return _react2.default.createElement(
	    "svg",
	    {
	      xmlns: "http://www.w3.org/2000/svg",
	      width: "108",
	      height: "108",
	      viewBox: "0 0 108 108"
	    },
	    _react2.default.createElement(
	      "g",
	      { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
	      _react2.default.createElement("path", { fill: "#FFF", d: "M0 0H108V108H0z" }),
	      _react2.default.createElement("path", {
	        fill: "#EFEFEF",
	        d: "M93 98a4 4 0 014 4v6H10v-6a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V73a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V44a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V15a4 4 0 014-4h79z"
	      }),
	      _react2.default.createElement("rect", { width: "43", height: "30", x: "33", y: "39", fill: "currentColor", rx: "4" }),
	      _react2.default.createElement("path", {
	        fill: "#FFF",
	        fillRule: "nonzero",
	        d: "M44.653 58.568c1.135 0 2.02-.256 2.652-.767.633-.511.949-1.205.949-2.08 0-.598-.165-1.081-.494-1.45-.33-.368-.767-.613-1.313-.734.468-.165.84-.412 1.118-.741.277-.33.416-.754.416-1.274 0-.364-.074-.7-.221-1.008a2.305 2.305 0 00-.637-.799 3.036 3.036 0 00-1.014-.527A4.539 4.539 0 0044.744 49a4.23 4.23 0 00-1.417.221 3.064 3.064 0 00-1.053.611 2.814 2.814 0 00-.682.943c-.16.36-.254.751-.28 1.176h1.859c.052-.442.21-.787.474-1.034.265-.247.618-.37 1.06-.37.433 0 .756.11.968.332.213.22.319.496.319.825 0 .399-.113.704-.338.916-.225.213-.585.319-1.079.319h-.676v1.404h.728c.503 0 .877.11 1.124.331.248.221.371.557.371 1.008 0 .416-.126.743-.377.981-.251.239-.641.358-1.17.358-.563 0-.973-.145-1.229-.435-.255-.29-.405-.661-.448-1.112H41c.043.945.366 1.697.968 2.256.603.559 1.498.838 2.685.838zm14.404-.143v-1.599h-3.614l1.755-1.716c.537-.52.97-1.044 1.3-1.573.33-.529.494-1.1.494-1.716 0-.416-.072-.797-.214-1.144a2.538 2.538 0 00-.618-.897 3.022 3.022 0 00-1.02-.572A4.203 4.203 0 0055.767 49c-1.049 0-1.879.282-2.49.845-.61.563-.942 1.387-.994 2.47h1.911c.07-.615.23-1.053.481-1.313s.585-.39 1.001-.39c.407 0 .715.113.923.338.208.225.312.533.312.923 0 .425-.132.847-.396 1.268a8.9 8.9 0 01-1.073 1.345l-3.406 3.601v.338h7.02zm7.982 0V49.13h-1.846l-2.145 1.521v1.794l1.885-1.235v7.215h2.106z"
	      })
	    )
	  );
	}
	
	exports.default = TimersPreview;
	module.exports = exports["default"];

/***/ }),

/***/ 587:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TransitionsIcon() {
	  return _react2.default.createElement(
	    "svg",
	    {
	      xmlns: "http://www.w3.org/2000/svg",
	      width: "25",
	      height: "24",
	      viewBox: "0 0 25 24"
	    },
	    _react2.default.createElement(
	      "g",
	      { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
	      _react2.default.createElement(
	        "g",
	        { fill: "#FFF", fillRule: "nonzero", transform: "translate(-564 -2143)" },
	        _react2.default.createElement(
	          "g",
	          { transform: "translate(531 1975)" },
	          _react2.default.createElement(
	            "g",
	            { transform: "translate(33 168)" },
	            _react2.default.createElement(
	              "g",
	              { transform: "translate(.5)" },
	              _react2.default.createElement("path", { d: "M9.49 14.51c.672.673.681 1.76.02 2.444L2.976 23.49A1.743 1.743 0 01.51 21.025l6.536-6.536a1.743 1.743 0 012.444.021zM11.089.17a1.556 1.556 0 011.64.141l3.625 2.704 4.13-1.48a1.556 1.556 0 011.976 1.977l-1.456 4.286 2.68 3.47c.36.472.417 1.11.147 1.639-.277.52-.818.847-1.408.85l-4.526-.055-2.476 3.63a1.556 1.556 0 01-2.767-.437l-1.34-4.322-4.208-1.226a1.556 1.556 0 01-.44-2.766l3.7-2.618-.127-4.384a1.556 1.556 0 01.85-1.41z" })
	            )
	          )
	        )
	      )
	    )
	  );
	}
	
	exports.default = TransitionsIcon;
	module.exports = exports["default"];

/***/ }),

/***/ 588:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TransitionsPreview() {
	  return _react2.default.createElement(
	    "svg",
	    {
	      xmlns: "http://www.w3.org/2000/svg",
	      width: "108",
	      height: "108",
	      viewBox: "0 0 108 108"
	    },
	    _react2.default.createElement(
	      "g",
	      { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
	      _react2.default.createElement("path", { fill: "#FFF", d: "M0 0H108V108H0z" }),
	      _react2.default.createElement("path", {
	        fill: "#EFEFEF",
	        d: "M93 98a4 4 0 014 4v6H10v-6a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V73a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V44a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V15a4 4 0 014-4h79z"
	      }),
	      _react2.default.createElement("path", { fill: "currentColor", d: "M52 0H108V108H52z" }),
	      _react2.default.createElement("path", {
	        fill: "#FFF",
	        fillRule: "nonzero",
	        d: "M80.19 65.983a1.333 1.333 0 001.048-1.313V54.615h6.147c.308 0 .615-.316.615-.632 0-.227-.086-.405-.25-.514l-.01-.01-6.877-7.081c-.442-.504-1.23-.504-1.729 0l-6.945 7.14c-.202.208-.24.435-.125.702.068.237.308.375.567.375h6.148V64.71c0 .77.682 1.403 1.412 1.274z",
	        transform: "rotate(-90 80 56)"
	      })
	    )
	  );
	}
	
	exports.default = TransitionsPreview;
	module.exports = exports["default"];

/***/ }),

/***/ 610:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Tag;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _generalModule = __webpack_require__(742);
	
	var _generalModule2 = _interopRequireDefault(_generalModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Tag(_ref) {
	  var children = _ref.children;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _generalModule2.default.tag },
	    children
	  );
	}
	
	Tag.propTypes = {
	  children: _propTypes2.default.node
	};
	module.exports = exports['default'];

/***/ }),

/***/ 742:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"tag":"src-components-modules-Tag-style----general-module---tag---2mZkR borderStyle-solid borderColor-smoke fontSize-s borderWidth-1 c-black paddingLeftRight-xs display-inlineFlex justifyContent-center alignItems-center bg-white"};

/***/ }),

/***/ 616:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _travelApp2x = __webpack_require__(881);
	
	var _travelApp2x2 = _interopRequireDefault(_travelApp2x);
	
	var _animatedApp2x = __webpack_require__(876);
	
	var _animatedApp2x2 = _interopRequireDefault(_animatedApp2x);
	
	var _financeApp2x = __webpack_require__(878);
	
	var _financeApp2x2 = _interopRequireDefault(_financeApp2x);
	
	var _hotelWebsite2x = __webpack_require__(879);
	
	var _hotelWebsite2x2 = _interopRequireDefault(_hotelWebsite2x);
	
	var _jobsWebsite2x = __webpack_require__(880);
	
	var _jobsWebsite2x2 = _interopRequireDefault(_jobsWebsite2x);
	
	var _doctorApp2x = __webpack_require__(877);
	
	var _doctorApp2x2 = _interopRequireDefault(_doctorApp2x);
	
	var _paths = __webpack_require__(617);
	
	var paths = _interopRequireWildcard(_paths);
	
	var _features = __webpack_require__(472);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var data = [{
	  name: 'Healthcare',
	  title: 'Healthcare app prototype inspiration',
	  description: 'A prototype with multiple flows and chat simulation for on-demand healthcare.',
	  path: paths.DOCTOR_APP,
	  previewImage: _doctorApp2x2.default,
	  prototypeSlug: '6g2c8e0',
	  features: [_features.CONTAINERS, _features.LAYERS, _features.TIMER],
	  isMobile: true,
	  tags: ['Health', 'Chat', 'Mobile']
	}, {
	  name: 'Chat',
	  title: 'Messaging app prototype example',
	  description: 'See how a gamified messaging app can be prototyped before handing off to developers.',
	  path: paths.ANIMATED_CHAT_APP,
	  previewImage: _animatedApp2x2.default,
	  prototypeSlug: 'j9750e',
	  features: [_features.TIMER, _features.GIF],
	  isMobile: true,
	  tags: ['Social Media', 'Gif', 'Timers']
	}, {
	  name: 'Hotel',
	  title: 'Hotel booking app prototype example',
	  description: 'A prototype for finding and booking holiday accommodation.',
	  path: paths.HOTEL_APP,
	  previewImage: _hotelWebsite2x2.default,
	  prototypeSlug: '13g69h4e',
	  features: [_features.EMBED, _features.CONTAINERS, _features.FIXED_HEADER_FOOTER],
	  isMobile: false,
	  tags: ['Travel', 'Website']
	}, {
	  name: 'Travel',
	  title: 'Travel app prototype inspiration | Marvel',
	  description: 'A simple prototype for finding and purchasing holidays.',
	  path: paths.TRAVEL_APP,
	  previewImage: _travelApp2x2.default,
	  prototypeSlug: '13g1eh24',
	  features: [_features.EMBED, _features.TRANSITIONS, _features.FIXED_HEADER_FOOTER],
	  isMobile: true,
	  tags: ['Travel', 'Mobile', 'Booking', 'Maps']
	}, {
	  name: 'Recruitment',
	  title: '',
	  description: 'An example of a desktop prototype for a recruitment website.',
	  path: paths.JOBS_WEBSITE,
	  previewImage: _jobsWebsite2x2.default,
	  prototypeSlug: '5j3628i',
	  features: [_features.EMBED, _features.CONTAINERS, _features.TRANSITIONS],
	  isMobile: false,
	  tags: ['Recruitment', 'Desktop', 'Containers', 'Embeds']
	}, {
	  name: 'Finance',
	  title: 'Banking app prototype example',
	  description: 'A large mobile banking prototype featuring several flows around.',
	  path: paths.FIANCE_APP,
	  previewImage: _financeApp2x2.default,
	  prototypeSlug: '6g00b39',
	  features: [_features.EMBED, _features.CONTAINERS, _features.FIXED_HEADER_FOOTER],
	  isMobile: true,
	  tags: ['Finance', 'Mobile']
	}];
	
	exports.default = data;
	module.exports = exports['default'];

/***/ }),

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.TRANSITIONS = exports.LAST_VISITED = exports.TIMER = exports.GIF = exports.LAYERS = exports.FIXED_HEADER_FOOTER = exports.EMBED = exports.SCROLL_TO_ANCHOR = exports.LINK = exports.CONTAINERS = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContainersIcon = __webpack_require__(571);
	
	var _ContainersIcon2 = _interopRequireDefault(_ContainersIcon);
	
	var _ContainersPreview = __webpack_require__(572);
	
	var _ContainersPreview2 = _interopRequireDefault(_ContainersPreview);
	
	var _AnchorIcon = __webpack_require__(569);
	
	var _AnchorIcon2 = _interopRequireDefault(_AnchorIcon);
	
	var _AnchorPreview = __webpack_require__(570);
	
	var _AnchorPreview2 = _interopRequireDefault(_AnchorPreview);
	
	var _EmbedIcon = __webpack_require__(573);
	
	var _EmbedIcon2 = _interopRequireDefault(_EmbedIcon);
	
	var _EmbedPreview = __webpack_require__(576);
	
	var _EmbedPreview2 = _interopRequireDefault(_EmbedPreview);
	
	var _EmbedMultimedia = __webpack_require__(574);
	
	var _EmbedMultimedia2 = _interopRequireDefault(_EmbedMultimedia);
	
	var _EmbedMultimediaPreview = __webpack_require__(575);
	
	var _EmbedMultimediaPreview2 = _interopRequireDefault(_EmbedMultimediaPreview);
	
	var _FixedHeaderFooter = __webpack_require__(577);
	
	var _FixedHeaderFooter2 = _interopRequireDefault(_FixedHeaderFooter);
	
	var _FixedHeaderFooterPreview = __webpack_require__(578);
	
	var _FixedHeaderFooterPreview2 = _interopRequireDefault(_FixedHeaderFooterPreview);
	
	var _Layers = __webpack_require__(583);
	
	var _Layers2 = _interopRequireDefault(_Layers);
	
	var _LayersPreview = __webpack_require__(584);
	
	var _LayersPreview2 = _interopRequireDefault(_LayersPreview);
	
	var _Timers = __webpack_require__(585);
	
	var _Timers2 = _interopRequireDefault(_Timers);
	
	var _TimersPreview = __webpack_require__(586);
	
	var _TimersPreview2 = _interopRequireDefault(_TimersPreview);
	
	var _LastVisited = __webpack_require__(581);
	
	var _LastVisited2 = _interopRequireDefault(_LastVisited);
	
	var _LastVisitedPreview = __webpack_require__(582);
	
	var _LastVisitedPreview2 = _interopRequireDefault(_LastVisitedPreview);
	
	var _Transitions = __webpack_require__(587);
	
	var _Transitions2 = _interopRequireDefault(_Transitions);
	
	var _TransitionsPreview = __webpack_require__(588);
	
	var _TransitionsPreview2 = _interopRequireDefault(_TransitionsPreview);
	
	var _Gif = __webpack_require__(579);
	
	var _Gif2 = _interopRequireDefault(_Gif);
	
	var _GifPreview = __webpack_require__(580);
	
	var _GifPreview2 = _interopRequireDefault(_GifPreview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CONTAINERS = exports.CONTAINERS = 'CONTAINERS';
	var LINK = exports.LINK = 'LINK';
	var SCROLL_TO_ANCHOR = exports.SCROLL_TO_ANCHOR = 'SCROLL_TO_ANCHOR';
	var EMBED = exports.EMBED = 'EMBED';
	var FIXED_HEADER_FOOTER = exports.FIXED_HEADER_FOOTER = 'FIXED_HEADER_FOOTER';
	var LAYERS = exports.LAYERS = 'LAYERS';
	var GIF = exports.GIF = 'GIF';
	var TIMER = exports.TIMER = 'TIMER';
	var LAST_VISITED = exports.LAST_VISITED = 'LINK_LAST_VISITED';
	var TRANSITIONS = exports.TRANSITIONS = 'TRANSITIONS';
	
	var features = [{
	  id: EMBED,
	  name: 'Embed',
	  description: 'Add dynamic content like videos, audio and maps',
	  helpId: '360003855577',
	  icon: _react2.default.createElement(_EmbedMultimedia2.default, null),
	  preview: _react2.default.createElement(_EmbedMultimediaPreview2.default, null),
	  color: '#FFD79B'
	}, {
	  id: TRANSITIONS,
	  name: 'Transitions',
	  description: 'Add realistic animations when transitioning to a hotspot',
	  helpId: '360017013198',
	  icon: _react2.default.createElement(_Transitions2.default, null),
	  preview: _react2.default.createElement(_TransitionsPreview2.default, null),
	  color: '#FF977A'
	}, {
	  id: CONTAINERS,
	  name: 'Containers',
	  description: 'Enable elements to scroll horizontally or vertically',
	  helpId: '360014699118',
	  preview: _react2.default.createElement(_ContainersPreview2.default, null),
	  icon: _react2.default.createElement(_ContainersIcon2.default, null),
	  color: '#AD6EDD'
	}, {
	  id: LINK,
	  name: 'Link',
	  description: 'Link to any external website, document or surveys',
	  helpId: '360003842897',
	  preview: _react2.default.createElement(_EmbedPreview2.default, null),
	  icon: _react2.default.createElement(_EmbedIcon2.default, null),
	  color: '#60D2C9'
	}, {
	  id: SCROLL_TO_ANCHOR,
	  name: 'Scroll to anchor',
	  description: 'Automatically scroll to another area on the same page',
	  helpId: '207646029',
	  icon: _react2.default.createElement(_AnchorIcon2.default, null),
	  preview: _react2.default.createElement(_AnchorPreview2.default, null),
	  color: '#FD6F3C'
	}, {
	  id: FIXED_HEADER_FOOTER,
	  name: 'Fixed header/footer',
	  description: 'Keep the top or bottom of the design fixed while the rest of the screen scrolls',
	  helpId: '209299185',
	  icon: _react2.default.createElement(_FixedHeaderFooter2.default, null),
	  preview: _react2.default.createElement(_FixedHeaderFooterPreview2.default, null),
	  color: '#2A3440'
	}, {
	  id: LAYERS,
	  name: 'Layer an image',
	  description: 'Add elements on top of your screen to recreate modals, tooltips and more',
	  helpId: '209299205',
	  icon: _react2.default.createElement(_Layers2.default, null),
	  preview: _react2.default.createElement(_LayersPreview2.default, null),
	  color: '#FFAE30'
	}, {
	  id: GIF,
	  name: 'Gif Animation',
	  description: 'Add GIFs to create animated areas in your prototype',
	  helpId: '360017022798',
	  icon: _react2.default.createElement(_Gif2.default, null),
	  preview: _react2.default.createElement(_GifPreview2.default, null),
	  color: '#FFC772'
	}, {
	  id: TIMER,
	  name: 'Timers',
	  description: 'Transition between screens after a set amount of time',
	  helpId: '360002731437',
	  icon: _react2.default.createElement(_Timers2.default, null),
	  preview: _react2.default.createElement(_TimersPreview2.default, null),
	  color: '#1FB6FF'
	}, {
	  id: LAST_VISITED,
	  name: 'Link to last visited screen',
	  description: 'Automatically link to the previous screen the user visited',
	  helpId: '360017019778',
	  icon: _react2.default.createElement(_LastVisited2.default, null),
	  preview: _react2.default.createElement(_LastVisitedPreview2.default, null),
	  color: '#60D956'
	}];
	
	exports.default = features;

/***/ }),

/***/ 617:
/***/ (function(module, exports) {

	'use strict';
	
	// When you change this file you need to rerun 'yarn start'
	
	module.exports = Object.freeze({
	  JOBS_WEBSITE: '/examples/recruitment-website',
	  TRAVEL_APP: '/examples/travel-app',
	  FIANCE_APP: '/examples/banking-app',
	  ANIMATED_CHAT_APP: '/examples/animated-chat-app',
	  DOCTOR_APP: '/examples/healthcare-app',
	  HOTEL_APP: '/examples/hotel-app'
	});

/***/ }),

/***/ 876:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/animated-app@2x-59ee921d7efeb942898328af0f844d35.jpg";

/***/ }),

/***/ 877:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/doctor-app@2x-ee6d93df970fdd77f6a7b490e8900975.jpg";

/***/ }),

/***/ 878:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/finance-app@2x-174b5f66da977076af3d72acb582dfde.jpg";

/***/ }),

/***/ 879:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hotel-website@2x-d3eb51e790ba854d830efcf5fb66c76a.jpg";

/***/ }),

/***/ 880:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/jobs-website@2x-263884c3c35fd4fbf04b7f0721a058a2.jpg";

/***/ }),

/***/ 881:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/travel-app@2x-13c2fc7be454da82bef3038487d5338e.jpg";

/***/ }),

/***/ 1270:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Card;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Tag = __webpack_require__(610);
	
	var _Tag2 = _interopRequireDefault(_Tag);
	
	var _cardModule = __webpack_require__(1502);
	
	var _cardModule2 = _interopRequireDefault(_cardModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Card(_ref) {
	  var title = _ref.title,
	      description = _ref.description,
	      previewImage = _ref.previewImage,
	      path = _ref.path,
	      tags = _ref.tags;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _cardModule2.default.card },
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: path },
	      _react2.default.createElement(
	        'div',
	        { className: _cardModule2.default.preview },
	        _react2.default.createElement(
	          'div',
	          { className: _cardModule2.default.previewImage },
	          _react2.default.createElement(_Image2.default, { hasShadow: false, src: previewImage, alt: title })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _cardModule2.default.title },
	      title
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _cardModule2.default.description },
	      description
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _cardModule2.default.tags },
	      tags.map(function (tag) {
	        return _react2.default.createElement(
	          'div',
	          { className: _cardModule2.default.tag, key: tag.id },
	          _react2.default.createElement(
	            _Tag2.default,
	            null,
	            tag
	          )
	        );
	      })
	    )
	  );
	}
	
	Card.propTypes = {
	  title: _propTypes2.default.string.isRequired,
	  path: _propTypes2.default.string.isRequired,
	  tags: _propTypes2.default.array.isRequired,
	  description: _propTypes2.default.string.isRequired,
	  previewImage: _propTypes2.default.node.isRequired
	};
	module.exports = exports['default'];

/***/ }),

/***/ 1271:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Examples;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _Page = __webpack_require__(16);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _metadata = __webpack_require__(22);
	
	var _metadata2 = _interopRequireDefault(_metadata);
	
	var _data = __webpack_require__(616);
	
	var _data2 = _interopRequireDefault(_data);
	
	var _generalModule = __webpack_require__(1503);
	
	var _generalModule2 = _interopRequireDefault(_generalModule);
	
	var _Card = __webpack_require__(1270);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Examples() {
	  return _react2.default.createElement(
	    _Page2.default,
	    {
	      title: _metadata2.default.examples.title,
	      meta: [{
	        name: 'description',
	        content: _metadata2.default.examples.description
	      }],
	      banner: true,
	      header: true,
	      footer: true
	    },
	    _react2.default.createElement(
	      'div',
	      { className: 'overflow-hidden' },
	      _react2.default.createElement(
	        'div',
	        { className: _generalModule2.default.wrap },
	        _react2.default.createElement(
	          'h1',
	          { className: _generalModule2.default.heading },
	          'Example Prototypes'
	        ),
	        _react2.default.createElement(
	          _spacing2.default,
	          { size: 'l', type: 'padding', position: 'bottom' },
	          _react2.default.createElement(
	            _maxWidth2.default,
	            { value: 720 },
	            _react2.default.createElement(
	              'p',
	              { className: _generalModule2.default.subheading },
	              'Discover the endless possibilities of building prototypes in Marvel. Click an example to see it in action.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _generalModule2.default.grid },
	          _data2.default.map(function (example) {
	            return _react2.default.createElement(_Card2.default, {
	              key: example.url,
	              title: example.name,
	              description: example.description,
	              previewImage: example.previewImage,
	              path: example.path,
	              tags: example.tags
	            });
	          })
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 1502:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"card":"src-pages-examples-style----card-module---card---3M9-K textAlign-left","preview":"src-pages-examples-style----card-module---preview---8S-XO bg-snow position-relative overflow-hidden opacity-80--hover borderRadius-l width-100","previewImage":"src-pages-examples-style----card-module---previewImage---2bX84 position-absolute","title":"src-pages-examples-style----card-module---title---3cx58 fontWeight-6 marginTop-m marginBottom-xs fontSize-xl c-black lineHeight-title breakPointL-fontSize-xxl","description":"src-pages-examples-style----card-module---description---ACv26 fontWeight-4 fontSize-m c-steel marginBottom-s lineHeight-copy breakPointL-fontSize-l","tag":"src-pages-examples-style----card-module---tag---3WDHT display-inlineBlock marginBottom-xs marginRight-xs"};

/***/ }),

/***/ 1503:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrap":"src-pages-examples-style----general-module---wrap---Fs2kt pageWrap c-black textAlign-center pageWrap-l","grid":"src-pages-examples-style----general-module---grid---IpGhY c-black marginBottom-xl textAlign-center","heading":"src-pages-examples-style----general-module---heading---5yofN marginBottom-m fontWeight-6 fontSize-xxxl lineHeight-title breakPointS-fontSize-xxxxl","subheading":"src-pages-examples-style----general-module---subheading---1Lb66 fontSize-l lineHeight-copy c-slate marginBottom-l breakPointS-fontSize-xl breakPointM-fontSize-xxl breakPointM-lineHeight-xxl fontWeight-4"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-examples-index-js-a8baaa4d58997dc6576a.js